export const sampleData = [
    ["Jane","doe","jane@doe.com","Doe Company","doe.com","owner","The doe company does x"]
]

export const sampleHeaders = ["first_name","last_name","email","company_name","website","role_at_business","notes"]
